const getAcceptFileAttr = (attrs: string[]) => attrs.join(', ');

export default getAcceptFileAttr;
